export default "__VITE_ASSET__CJR6Iocj__"